<template>
  <div style="width:100%;padding:15px;display:flex;justify-content: center;">
    <div style="width:500px">
      <el-form
        :label-width="labelWidth"
        :model="fM"
        :rules="fR"
        ref="cFormRef"
      >
        <el-form-item
          :key="index"
          v-for="(item, index) in fS"
          :label="t(item.label)"
          :prop="item.prop"
        >
          <template v-if="item.component==='el-cascader'">
            <el-cascader
              :is="item.component"
              :id="item.prop"
              :placeholder="item.placeholder"
              :options="item.options"
              v-model="fM[item.prop]"
              style="width:100%"
            />
          </template>
          <!-- radio 选项 -->
          <template v-else-if="item.component === 'el-radio-group'">
            <el-radio-group
              :is="item.component"
              :id="item.prop"
              :type="item.type"
              v-model="fM[item.prop]"
              :disabled="readonly || item.readonly"
            >
              <el-radio
                v-for="(option, optionIndex) in item.options"
                :key="optionIndex"
                :label="option.value"
              >
                {{ option.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-else>
            <component
              :is="item.component"
              :id="item.prop"
              :type="item.type"
              :placeholder="item.placeholder"
              :min="item.min"
              :max="item.max"
              :maxlength="item.maxlength"
              :filterable="item.filterable"
              :disabled="item.disabled"
              :multiple="item.multiple"
              :readonly="readonly || item.readonly"
              :remote="item.remote"
              :remote-method="item.remoteMethod"
              :loading="item.loading"
              v-model="fM[item.prop]"
              clearable
              :show-password="item.showPassword"
              :show-word-limit="item.showWordLimit"
              style="width:100%"
            >
              <template v-if="item.component==='el-select'">
                <el-option
                  v-for="(optionItem, optionIndex) in item.options"
                  :key="optionIndex"
                  :label="optionItem.label"
                  :value="optionItem.value"
                />
              </template>
            </component>
          </template>
        </el-form-item>
        <slot
          :row="fM"
        />
        <el-form-item v-if="!readonly && showButton">
          <el-button
            type="primary"
            @click="submitEmit"
          >
            {{ t(submitButton) }}
          </el-button>
          <el-button
            @click="resetEmit"
          >
            {{ t(resetButton) }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script lang="ts">
import { ElForm } from 'element-plus'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => [] as any
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    },
    labelWidth: {
      type: String,
      required: false,
      default: '150px'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    showButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const cFormRef = ref(ElForm)
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const fR = ref(props.formRules)
    const submitEmit = () => {
      (cFormRef.value as typeof ElForm).validate((valid: any) => {
        if (valid) {
          context.emit('submit')
        }
      })
    }
    const resetEmit = () => {
      (cFormRef.value as typeof ElForm).resetFields()
      context.emit('reset')
    }
    const validate = () => {
      return cFormRef.value.validate()
    }
    const resetFields = () => {
      return cFormRef.value.resetFields()
    }
    return {
      t,
      fM,
      fS,
      fR,
      cFormRef,
      submitEmit,
      resetEmit,
      validate,
      resetFields
    }
  }
})
</script>
